import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType, } from '../../constants';

export class GaTrackingRegistrationTypeClickEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string,
    private label: string,
    private action: string) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.RegistrationTypeClicked;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.RegistrationTypeClicked,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
      }
    };
  }
}
